import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from '@weezevent/nacre';
import Style from './swapSession.module.css';

import { useTranslation } from 'react-i18next';
import useAppContext from '../../../../../context/useAppContext';
import moment from 'moment-timezone';
import LabelDetails from '../label-details/labelDetails';
import SwapSessionAction from '../../../actions/swapSessionAction';
import i18n from 'i18next';

export default function SwapSession({ attendee, title = null, onChangeAction = () => {} }) {
    const { t } = useTranslation();
    const [{ event, event_timezone }] = useAppContext();
    const locale = i18n.language;

    const sessionDate = React.useMemo(() => {
        if (!attendee?.booking || !event.use_sessions || !attendee?.booking.inventory_weez_date_id || !attendee.booking.inventory_start_date) {
            return null;
        }

        let dateLocalized = moment.tz(
            moment
                .utc(attendee.booking.inventory_start_date, moment.ISO_8601)
                .tz(event_timezone)
                .format('YYYY-MM-DD HH:mm'),
            event_timezone
        );

        return Intl.DateTimeFormat(locale, { dateStyle: 'full', timeStyle: 'short' }).format(new Date(dateLocalized));
    }, [attendee, event, event_timezone, locale]);

    const _onClick = React.useCallback(() => {
        onChangeAction({ action: SwapSessionAction, items: [attendee], currentSessionDate: sessionDate });
    }, [onChangeAction, sessionDate]);

    if (!event.use_sessions || !attendee?.booking || !attendee.booking.inventory_weez_date_id || !attendee.booking.inventory_start_date) {
        return null;
    }

    return (
        <div className={Style['container']}>
            <div className={Style['content']}>
                {title && <div className={Style['title']}>{title}</div>}
                <LabelDetails title={t('ticket.event.start_date')}>{sessionDate}</LabelDetails>
            </div>
            {!event.is_seated && (
                <div className={Style['footer']}>
                    <div className={Style['edit']} onClick={_onClick}>
                        <span className={Style['edit-label']}>{t('ticket.manager.attendees.action.swap_session.dropdownItem')}</span>
                        <Icon name="edit" className={Style['edit-icon']} />
                    </div>
                </div>
            )}
        </div>
    );
}

SwapSession.propTypes = {
    attendee: PropTypes.object.isRequired,
    title: PropTypes.node,
    onChangeAction: PropTypes.func
};
